import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { SEO } from '../seo/SEO';

/**
 * 404 page — emitted by the SPA's catch-all route.
 *
 * Important for SEO:
 *  - `noIndex` ensures Google does not index unknown deep links as content.
 *  - Visible UI text is generic and short; we don't add any new branding here.
 */
const NotFoundPage = () => (
  <div className="min-h-screen bg-background flex flex-col items-center justify-center px-4 text-center">
    <SEO
      title="Page not found"
      description="The page you are looking for could not be found."
      noIndex
      includeRestaurantSchema={false}
    />
    <h1 className="text-5xl font-bold mb-2">404</h1>
    <p className="text-muted-foreground mb-6">Page not found.</p>
    <Link to="/">
      <Button className="rounded-full">Back to home</Button>
    </Link>
  </div>
);

export default NotFoundPage;
